import gql from "graphql-tag";

export const GET_CHALLENGES = gql`
  query getChallenges($clientName: String!) {
    getChallenges(clientName: $clientName) {
      _id
      clientName
      published
      title
      description
      difficulty
      duration
      commitment
      imageLink
      startDate
      communityId
      adminCommunityId
      type
      welcomeItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
      endingItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
      }
      schedule {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        startDay
        endDay
        notifications {
          title
          message
          time
        }
        community
        adminCommunity
        notificationTitle
        notificationMessage
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
    }
  }
`;

export const GET_CHALLENGE = gql`
  query getChallenge($challengeId: ID!) {
    getChallenge(challengeId: $challengeId) {
      _id
      clientName
      published
      title
      description
      difficulty
      duration
      commitment
      imageLink
      startDate
      communityId
      adminCommunityId
      type
      welcomeItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
      endingItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
      }
      schedule {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        startDay
        endDay
        notifications {
          title
          message
          time
        }
        community
        adminCommunity
        notificationTitle
        notificationMessage
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
    }
  }
`;

export const GET_CLIENT = gql`
  query GetClient($name: String!) {
    getClient(name: $name) {
      _id
      name
      appName
      address
      city
      state
      zip
      vibeonixApiKey
      webhookApiKey
      androidPackageName
      androidPackageNameRelieph
      googleServiceEmail
      googleServiceEmailRelieph
      googleServicePrivateKey
      googleServicePrivateKeyRelieph
      appleSharedSecret
      appleSharedSecretRelieph
      stripeApiKey
      stripeApiKeyDev
      appStoreURL
      playStoreURL
      adminUsers {
        _id
        clientId
        clientName
        fullName
        email
        password
        status
        purchasedCourses
      }
      openAISystemMessage
      tutorials {
        _id
        page
        title
        videoURL
        description
        allowedSkips
      }
      lessons {
        _id
        title
        age
        grade
        lessonNumber
        videoLink
        activities
      }
      courses {
        _id
        title
        age
        description
        imageLink
        groups
        lessons {
          _id
          title
          age
          lessonNumber
          videoLink
          activities
        }
        watchedStatus
        price
      }
      meditations {
        _id
        title
        age
        description
        audioLink
      }
      visualizations {
        _id
        title
        age
        description
        audioLink
      }
      movements {
        _id
        title
        age
        description
        videoLink
      }
      habits {
        _id
        title
        description
        type
        options
        value
      }
      resourceFolders {
        _id
        name
        type
        resources {
          _id
          name
          type
          uploadDate
          link
        }
      }
      notifications {
        _id
        title
        message
        frequency
        date
        time
        filters {
          challengeId
          isCoach
        }
      }
      storeSignup
    }
  }
`;
